import { List, TextField, TextInput, useDataProvider } from 'react-admin';
import Datagrid from '../Commons/Datagrid';
import PostPagination from '../Commons/PostPagination';
import ListActions from '../Commons/ListActions';
import { useMediaQuery, createTheme } from '@mui/material';
import BreadCrumbCustom from '../Commons/BreadCrum';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import historyTracker from '../Commons/historyTracker';
import AuthNotification from '../Commons/AuthNotification';
import { StyleTheme, Style } from '../Commons/Styles.jsx';
import { createStyles, makeStyles } from '@mui/styles';
import FilterSidebar from '../Commons/FilterSidebar';
import InternalMenu from '../Commons/InternalMenu';
import CircularProgress from '@mui/material/CircularProgress';
// TODO: reemplazar por el ícono definitivo de Proveedores cuando esté disponible
import providers from '../Commons/Icons/apps.svg';
import providerList from '../Commons/Icons/book.svg';

import { hasPermissions } from '../Commons/CompanyAuth';

const useStyles = makeStyles(() => createStyles(StyleTheme));

const ProvidersList = (props) => {
  const classes = useStyles();
  const theme = createTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const [openAuth, setOpenAuth] = useState(false);
  const [auth, setAuth] = useState(false);
  const [authCreate, setAuthCreate] = useState(false);
  // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
  // "initialLoading" en el return): sin este estado la ventana se veia en blanco
  // (solo el breadcrumb) mientras se traian los permisos.
  const [initialLoading, setInitialLoading] = useState(true);
  const dataProvider = useDataProvider();

  useEffect(() => {
    (async () => {
      try {
        const currentPath = location.pathname;
        historyTracker.addPath(currentPath, 'Proveedores', 2);

        const authdata = { data: hasPermissions('Provider', 'list,create') };
        if (authdata.data.length > 0) {
          setAuth(authdata.data[0]);
          setOpenAuth(!authdata.data[0]);
          setAuthCreate(authdata.data[1]);
        } else {
          setAuth(false);
          setOpenAuth(true)
        }
      }
      catch {
      }
      finally {
        setInitialLoading(false);
      }
    })();
  }, [dataProvider, location.pathname]);

  const PostFilter = [
    <TextInput InputProps={{ disableUnderline: true }} label={<span>{"Nombre"}</span>} source="name" alwaysOn />,
    <TextInput InputProps={{ disableUnderline: true }} label={<span>{"Nit"}</span>} source="nit" alwaysOn />,
  ];

  const handleRedirectProviderList = () => {
    navigate(`/provider`);
  };

  const [openProviders, setOpenProviders] = useState(true);

  const handleClickOpenProviders = () => {
    setOpenProviders(!openProviders);
  };

  const menus = [{
    icon: <img src={providers} alt="logo" style={Style.MenuLogo} />, name: 'Proveedores',
    open: openProviders,
    openAction: handleClickOpenProviders,
    actions: [
      { icon: <img src={providerList} alt="logo" style={Style.MenuLogo} />, name: 'Listado', onClick: handleRedirectProviderList },
    ]
  }];

  let pagination = <PostPagination menu={<InternalMenu menus={menus} />} />;

  return (
    <div class="container">
      <BreadCrumbCustom history={historyTracker.getHistory()} />
      {initialLoading ? (
        // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y
        // el mismo CircularProgress que ya se usa en otras pantallas para el
        // guardado, pero aqui cubre la espera de auth, que antes dejaba la
        // pantalla en blanco.
        <div class="Loading" style={{ display: 'block' }}>
          <CircularProgress size="15rem" />
        </div>
      ) : auth ? (
        <div class="row">
          <div class="col-12">
            {isSmall ? (
              <List empty={false} {...props} actions={<ListActions create={authCreate} />} bulkActionButtons={false} pagination={pagination}>
                <Datagrid {...props} rowClick="show">
                </Datagrid>
              </List>
            ) : (
              <List empty={false} perPage={10} {...props} aside={<FilterSidebar {...props} filters={PostFilter} />} actions={<ListActions download create={authCreate} />} bulkActionButtons={false} pagination={pagination}>
                <Datagrid {...props} rowClick="show" style={Style.DataGrid}>
                  <TextField source="name" style={Style.fieldList} label="Nombre" cellClassName={classes.fields} />
                  <TextField source="nit" style={Style.fieldList} label="Nit" cellClassName={classes.fields} />
                </Datagrid>
              </List>
            )}
          </div>
        </div>) : (<AuthNotification openerror={openAuth} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)}
    </div>
  )
};

export default ProvidersList;
